import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tableCommon-wrapper"
  }, [_c("a-table", {
    attrs: {
      columns: _vm.tableHead,
      dataSource: _vm.tableData,
      loading: _vm.loading,
      pagination: _vm.pagination,
      "row-selection": _vm.rowSelection,
      rowKey: "id",
      scroll: _vm.scroll,
      bordered: ""
    },
    on: {
      change: _vm.handleTableChange
    },
    scopedSlots: _vm._u([_vm._l(Object.keys(_vm.$scopedSlots).filter(key => key !== "expandedRowRender"), function (slot) {
      return {
        key: slot,
        fn: function (text, record, index) {
          return [_vm._t(slot, null, null, {
            text,
            record,
            index
          })];
        }
      };
    })], null, true)
  }, _vm._l(_vm.tableHead, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };